import { useState, useEffect } from "react";
import NewProjectTemplate from "../../Templates/NewProject";
import { useKeycloak } from "@react-keycloak/web";
import companyService from "../../../services/Companies/CompanyService";

export default function NewProject() {
    const { keycloak, initialized } = useKeycloak();
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        loadAllCompanies();
    }, [initialized, keycloak.token])

    const loadAllCompanies = async () => {
        try {
            const allCompanies = await companyService.getAllCompanies(keycloak.token);
            setCompanies(allCompanies);
        } catch (error) {
            console.error("Error to get all companies", error);
        }
    }
    return (
        <NewProjectTemplate companies={companies} onCompanyCreated={loadAllCompanies} />
    )
}